// ===== Hero section ===================
const Hero = () => {
  // scroll to related section
  const scrollTo_Section = (sec_id) => {
    let element = document.getElementById(sec_id);
    var yOffset = -50;

    if (element) {
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };
  return (
    <section id="hero">
      <div className="cs_container">
          <div className="cs_row hero_row align-items-center justify-content-center">
            <div className="hero_content">
              <h1 className='font_spaced'>Welcome to <br /></h1>
              <img width="490" src="/logo.png" alt="SPACE WARRIORS" />
              <button className="cta-btn thd-btn" onClick={() => scrollTo_Section("about")}>
                <div className="div-hide">
                  <div className="cta-btn-top-text">Scroll!</div>
                  <div className="cta-btn-text">Scroll!</div>
                </div>
                <div className="cta-btn-sm-text"></div>
              </button>
            </div>
          </div>
      </div>
    </section>
  )
}

export default Hero